var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WorkTableDialog',{ref:"deputyDialog",attrs:{"headers":_vm.headers,"path":"users/deputies","mandatory-filters":{ isActive: true },"get-data":_vm.getData,"title":_vm.$t('DeputyPopup.title')}})
}
var staticRenderFns = []

export { render, staticRenderFns }